import { Component, Input } from "@angular/core";

@Component({
    selector: "validation",
    templateUrl: "validation.component.html",
    standalone: false
})
export class ValidationComponent {
  @Input() ValidationLabel = "";
  @Input() ValidationList = [];
}
